import styled from '@emotion/styled';
import {
  TextParagraph,
  token,
  VerifiedFillSmallIcon,
} from '@ferreri/prever-component-lib';

import { Feedback } from './feedbacks';

type FeedbackCardProps = {
  feedback: Feedback;
};

export const FeedbackCard = ({ feedback }: FeedbackCardProps) => {
  const stars = '★'.repeat(Math.floor(feedback.rating));

  return (
    <CardContainer>
      <CardHeader>
        <CardName>{feedback.name}</CardName>
        <VerifiedBadge>
          <VerifiedFillSmallIcon color={token.colors.feedbackSuccessPrimary} />
          <VerifiedText>Avaliação verificada</VerifiedText>
        </VerifiedBadge>
      </CardHeader>
      <RatingContainer>
        <Stars>{stars}</Stars>
        <RatingText>
          {feedback.rating.toFixed(1)} ({feedback.platform})
        </RatingText>
      </RatingContainer>
      <Description>{feedback.description}</Description>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  background-color: white;
  border-radius: 24px;
  padding: ${token.spacing.spacingMedium};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  width: 280px;
  height: 200px;
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXSmall};

  @media (min-width: 768px) {
    width: 400px;
    height: 246px;
    padding: ${token.spacing.spacingMedium};
  }
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXxSmall};
  flex-shrink: 0;
`;

const CardName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${token.colors.neutralXxDark};
  font-family: ${token.typography.fontFamily01};
  margin: 0;
`;

const VerifiedBadge = styled.div`
  display: flex;
  align-items: center;
  gap: ${token.spacing.spacingXxxSmall};
`;

const VerifiedText = styled.span`
  font-size: 12px;
  color: ${token.colors.neutralXDark};
  font-family: ${token.typography.fontFamily01};
`;

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${token.spacing.spacingXxxSmall};
  flex-shrink: 0;
`;

const Stars = styled.span`
  font-size: 14px;
  color: ${token.colors.feedbackWarningPrimary};
`;

const RatingText = styled.span`
  font-size: 12px;
  color: ${token.colors.neutralXDark};
  font-family: ${token.typography.fontFamily01};
`;

const Description = styled(TextParagraph)`
  color: ${token.colors.neutralXxDark} !important;
  font-size: 10px;

  @media (min-width: 768px) {
    font-size: 12px;
  }
`;
